import api from '../../plugins/api';

// GET /api/crm/vin-blacklist/cars â Ð¼Ð°ÑÐ¸Ð½Ñ, ÐºÐ¾ÑÐ¾ÑÑÐµ ÑÐ¶Ðµ ÐµÑÑÑ Ð² Ð±Ð°Ð·Ðµ Ñ VIN Ð¸Ð· ÑÑÑÐ½Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ° (Ð¾ÑÑÐ°ÑÐ¾Ðº, ÑÐ´ÐµÐ»ÐºÐ¸).
const getVinBlacklistCars = (params) => {
  return api.get('/api/crm/vin-blacklist/cars', params);
};

export default getVinBlacklistCars;
